import React, { PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";

const Layout = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 0;
`;

const Header = styled.div`
  padding: 0 40px;
  height: 75px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid #dadce0;
  flex-shrink: 0;
`;

const Column = styled.div`
  display: flex;
  align-items: center;
`;

const LeftColumn = styled(Column)`
  justify-content: left;
`;

const CenterColumn = styled(Column)`
  justify-content: center;
`;

interface ContentLayoutProps extends PropsWithChildren {
  centerColumn: ReactNode;
  leftColumn?: ReactNode;
}

const ContentLayout = (props: ContentLayoutProps) => {
  const { leftColumn, centerColumn, children } = props;

  return (
    <Layout>
      <Header>
        <LeftColumn>{leftColumn}</LeftColumn>
        <CenterColumn>{centerColumn}</CenterColumn>
      </Header>
      {children}
    </Layout>
  );
};

export default ContentLayout;
